<template>
    <v-layout>
        <v-flex xs12>
            <about-tile v-if="canViewAboutTile" :can-view-about="canViewAbout" :can-view-chair="canViewChair" :can-view-sponsors="canViewSponsors"></about-tile>
            <transaction-hub v-if="isBusinessNetworkPage && isVisible && canViewTransactionHub"></transaction-hub>
            <administration-options
                :title="Administration.NETWORK_ADMINISTRATION"
                :isNetwork="true"
                v-if="showAdminPanel && isVisible"></administration-options>
            <ypo-networks v-if="ypoNetworks"></ypo-networks>
            <filesand-media v-if="canViewFilesAndMedia"></filesand-media>
        </v-flex>
    </v-layout>
</template>

<script>
    import YpoNetworks from "../NetworkPage/YPONetwork";
    import { routerNames, userRoles } from '../appCommon.constants';
    import { mapActions, mapGetters } from "vuex";
    import { storeAction } from "@/store/storeActions.constant";
    import { storeGetters } from "@/store/storeGetters.constant";
    import { communityCommonConstant, networkConstants } from '../ChapterPage/communityCommon.constant';
    import FilesandMedia from "../ChapterPage/FilesandMedia/FilesandMedia";
    import TransactionHub from "../../components/ChapterPage/TransactionHub/TransactionHub";
    import AdministrationOptions from "./AdministrationOption";
    import AboutTile from '../ChapterPage/AboutTile/AboutTile';
    import { Administration } from "./NetworkConstants";
    import { trackEventConstant } from "@/plugins/analytics.constant";
    import communityLeftSideBarMixin from "../../mixins/communityLeftSideBarMixin";


    export default {
        name: 'NetworkLeftSidebar',
        mixins: [communityLeftSideBarMixin],
        created() {
            if (!this.ypoNetworks) {
                this.getYPONetworksList();
            }
            this.canViewPendingAssetRequest();
        },
        components: {
            YpoNetworks,
            AdministrationOptions,
            TransactionHub,
            FilesandMedia,
            AboutTile,
            trackEventConstant,
        },
        data: () => {
            return {
                networkType: null,
                isNetworkAdmin: false,
                communityCommonConstant,
                networkConstants,
                routerNames,
                Administration,
            };
        },
        methods: {
            ...mapActions({
                getInviteesList: `network/${storeAction.getInviteesList}`,
                getYPONetworksList: `network/${storeAction.getYPONetworks}`,
                canViewPendingAssetRequest: `network/${storeAction.canViewPendingAssetRequest}`,
            }),
            isBusinessNetworkPage() {
                return this.$route.name === this.routerNames.NETWORK && true; // TODO enable the next line when we can inspect the current communityType
            },
        },
        computed: {
            ...mapGetters({
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                ypoNetworks: `network/${storeGetters.ypoNetworks}`,
                currentCommunityView: `${storeGetters.currentCommunityView}`,
            }),
            isCurrentUserNetworkAdmin() {
                let isAdmin = false;
                let selectedCommunity;
                if (this.usersCommunitiesList && this.usersCommunitiesList.length > 0) {
                    selectedCommunity = this.usersCommunitiesList.find(o => o.communityId === this.$route.params.communityId);
                    isAdmin = selectedCommunity && selectedCommunity.isAdmin;
                }
                return isAdmin;
            },
            canViewFilesAndMedia() {
                return this.communityInfo
                    && this.communityInfo.communityId === this.$route.params.communityId
                    && this.communityInfo.userAccess
                    && this.communityInfo.userAccess.canViewAllFilesAndMedia;
            },
            canViewTransactionHub() {
                return this.communityInfo
                    && this.communityInfo.communityId === this.$route.params.communityId
                    && (this.communityInfo.communitySubType === this.communityCommonConstant.transactionHub.BUSINESS_COMMUNITY_TYPE
                        || this.communityInfo.communitySubType === this.communityCommonConstant.transactionHub.ALL_NETWORKS_COMMUNITY_TYPE)
                    && this.communityInfo.userAccess
                    && this.communityInfo.userAccess.canViewYpoTransactionHub;
            },
            showAdminPanel() {
                return this.communityInfo && this.communityInfo.isAdmin && this.currentCommunityView !== userRoles.MEMBER;
            },
            isVisible() {
                return this.$route.params.communityId;
            },
            area() {
                if (this.isVisible) {
                    return trackEventConstant.COMPONENT.NETWORK_PAGE;
                }
                return trackEventConstant.COMPONENT.NON_MEMBER_NETWORK_PAGE;
            },
        },
    };
</script>
